import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { UsersListPageService } from "../../../../../services";

const MODULE_NAME = "profile.machines.states.activateUser";
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.UsersListPageService") as UsersListPageService;
};

export const activateUser = async (context: any, event: any) => {
  const currentState = "ACTIVATE_USER";
  const method = "activateUser";

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);
      const srv = getSrv();
      const content = await srv.activateUser(event?.payload);
      if (content?.email) {
        return resolve({
          key: "ACTIVATE_USER_SUCCESS",
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = "User activation failed";
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: "ACTIVATE_USER_FAILED",
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: "ACTIVATE_USER_FAILED",
        value: err?.message,
      });
    }
  });
};
